module.exports = __webpack_public_path__ + "img/639-1f9e78.png";